import React, { useEffect, useState } from "react";
import useApi from "../../../CustomHooks/useApi";

/* SERVICE → API MAP */
const SERVICE_API_MAP = {
  aeps: "/aeps/transaction/history",
  dmt: "/dmt/transaction/history",
  recharge: "/recharge/transaction/history",
  payout: "/payout/history",
  creditCard: "/creditCard/txn/history",
};

const formatDateTime = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const amt = (v) => `₹${Number(v || 0).toFixed(2)}`;

const MerchantShTxnHistory = ({ mid, service }) => {
  const apiPath = SERVICE_API_MAP[service];
  const { callApi: history } = useApi(apiPath, "GET");

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (mid && apiPath) fetchHistory();
    // eslint-disable-next-line
  }, [mid, service]);

  const fetchHistory = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await history(null, `?merchant_user_name=${mid}`);
      setRows(Array.isArray(res?.data) ? res.data : res || []);
    } catch (err) {
      setError("Failed to load transaction history");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-600">{error}</p>;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead className="bg-slate-100 border-b border-slate-300 sticky top-0">
          <tr className="font-semibold text-slate-700">
            <th className="px-4 py-3 text-left border-r">Shop Name</th>
            <th className="px-4 py-3 text-left border-r">Merchant</th>
            <th className="px-4 py-3 text-right border-r">Net Amount</th>
            <th className="px-4 py-3 text-right border-r">Txn Amount</th>
            <th className="px-4 py-3 text-left border-r">Date & Time</th>
            <th className="px-4 py-3 text-left">Status</th>
          </tr>
        </thead>

        <tbody>
          {rows?.map((r, i) => (
            <tr
              key={i}
              className={`border-b border-slate-200 ${
                i % 2 === 0 ? "bg-white" : "bg-slate-50"
              } hover:bg-indigo-50`}
            >
              <td className="px-4 py-3 border-r">{r.shopName || "—"}</td>
              <td className="px-4 py-3 border-r">{r.merchantName || "—"}</td>

              <td className="px-4 py-3 text-right border-r font-semibold">
                {amt(r.netAmount)}
              </td>

              <td className="px-4 py-3 text-right border-r">
                {amt(r.txnAmount)}
              </td>

              <td className="px-4 py-3 border-r">
                {formatDateTime(r.date)}
              </td>

              <td className="px-4 py-3 font-semibold">
                <span
                  className={
                    r.txnStatus === "SUCCESS"
                      ? "text-green-600"
                      : "text-red-600"
                  }
                >
                  {r.txnStatus}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {rows.length === 0 && (
        <p className="text-center py-6 text-slate-500">
          No transactions found
        </p>
      )}
    </div>
  );
};

export default MerchantShTxnHistory;

